"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayName = exports.isAuth = exports.get = undefined;

var _reselect = require("reselect");

var _assert = require("@swarm2/assert");

var _users = require("../users");

var Users = _interopRequireWildcard(_users);

var _auth = require("../auth");

var Auth = _interopRequireWildcard(_auth);

var _raw = require("./raw");

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return (0, _assert.assertDefined)(s.user, "characters2.user", s);
});
var isAuth = exports.isAuth = (0, _reselect.createSelector)(get, Auth.userId, function (cu, au) {
  return cu === au;
});
var createUserSelector = function createUserSelector(selector) {
  return (0, _reselect.createSelector)(
  // a cacheable subset of root for the user-selectors below
  (0, _reselect.createStructuredSelector)({
    firebase: (0, _reselect.createStructuredSelector)({
      data: (0, _reselect.createStructuredSelector)({
        users: function users(root) {
          return root.firebase.data.users;
        }
      })
    })
  }), (0, _reselect.createStructuredSelector)({
    userId: get
  }), selector);
};
var displayName = exports.displayName = createUserSelector(Users.displayName);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/user.js
// module id = 810
// module chunks = 0